
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CardTitle, CardDescription, CardHeader } from "@/components/ui/card";

interface ProfileCardHeaderProps {
  isEditMode: boolean;
  loading: boolean;
  cancelEdit: () => void;
  enterEditMode: () => void;
  handleSubmit: () => void;
}

export const ProfileCardHeader = ({
  isEditMode,
  loading,
  cancelEdit,
  enterEditMode,
  handleSubmit
}: ProfileCardHeaderProps) => {
  return (
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <div>
        <CardTitle>Profile Details</CardTitle>
        <CardDescription>
          Manage your personal information and preferences
        </CardDescription>
      </div>
      {!isEditMode && (
        <Button 
          onClick={enterEditMode} 
          variant="outline" 
          size="sm" 
          className="flex items-center gap-2"
        >
          <Edit className="h-4 w-4" />
          Edit Profile
        </Button>
      )}
    </CardHeader>
  );
};
